
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The upper limit of hirers to return from the start of the list.`}</p>
    <p>{`Defaults to 10 if neither `}<inlineCode parentName="p">{`first`}</inlineCode>{` nor `}<inlineCode parentName="p">{`last`}</inlineCode>{` are specified.
Excess hirers will be trimmed from the end of the list.`}</p>
    <p><inlineCode parentName="p">{`first`}</inlineCode>{` and `}<inlineCode parentName="p">{`last`}</inlineCode>{` cannot be specified in the same query.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;